import { FC } from 'react';

export const Items: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.4679 3.87915C12.1752 3.7242 11.8248 3.7242 11.5321 3.87915L5.55045 7.04592L12 10.8398L18.4496 7.04592L12.4679 3.87915ZM19.5 8.74837L13 12.5719V19.8391L18.9679 16.6796C19.2953 16.5063 19.5 16.1662 19.5 15.7958V8.74837ZM11 19.8391V12.5719L4.5 8.74837V15.7958C4.5 16.1662 4.70475 16.5063 5.03211 16.6796L11 19.8391ZM10.5963 2.11158C11.4744 1.64673 12.5256 1.64673 13.4037 2.11158L20.9679 6.11617C21.2953 6.28948 21.5 6.62954 21.5 6.99995V15.7958C21.5 16.907 20.8858 17.9272 19.9037 18.4472L12.4679 22.3837C12.1752 22.5387 11.8248 22.5387 11.5321 22.3837L4.09634 18.4472C3.11425 17.9272 2.5 16.907 2.5 15.7958V6.99995C2.5 6.62954 2.70475 6.28948 3.03211 6.11617L10.5963 2.11158Z"
			fill="currentColor"
		/>
	</svg>
);
